export const COUNTRY_CITIES: Record<string, string[]> = {
  'Saudi Arabia': [
    'Riyadh', 'Jeddah', 'Makkah', 'Madinah', 'Dammam', 'Khobar', 'Dhahran',
    'Taif', 'Tabuk', 'Buraidah', 'Khamis Mushait', 'Abha', 'Hail', 'Najran',
    'Jazan', 'Yanbu', 'Al Ahsa', 'Jubail', 'Al Qatif', 'Arar', 'Sakaka',
    'Al Baha', 'Bisha', 'Unaizah', 'Al Kharj', 'Hafar Al-Batin', 'Al Majmaah',
    'Dawadmi', 'Afif', 'Wadi Al-Dawasir', 'Sharurah', 'Turaif', 'Rafha',
    'Al Lith', 'Rabigh', 'Al Qunfudhah', 'Muhayil', 'Al Namas', 'Tabarjal',
    'Dumat Al-Jandal', 'Al Ula', 'Khaybar', 'Badr', 'Al Hanakiyah', 'Mahd Al-Dhahab',
    'Al Zulfi', 'Shaqra', 'Hotat Bani Tamim', 'Al Aflaj', 'Layla', 'Al Dilam',
    'Samtah', 'Abu Arish', 'Sabya', 'Al Darb', 'Farasan',
  ],
  'United Arab Emirates': [
    'Dubai', 'Abu Dhabi', 'Sharjah', 'Ajman', 'Ras Al Khaimah', 'Fujairah',
    'Umm Al Quwain', 'Al Ain', 'Khor Fakkan', 'Kalba', 'Dibba Al-Hisn',
    'Dibba Al-Fujairah', 'Jebel Ali', 'Ghayathi', 'Liwa', 'Madinat Zayed',
    'Ruwais', 'Dhaid', 'Masafi', 'Hatta',
  ],
  'Qatar': [
    'Doha', 'Al Wakrah', 'Al Khor', 'Lusail', 'Al Rayyan', 'Umm Salal',
    'Al Daayen', 'Al Shamal', 'Al Shahaniya', 'Mesaieed', 'Dukhan',
  ],
  'Oman': [
    'Muscat', 'Salalah', 'Sohar', 'Nizwa', 'Sur', 'Ibri', 'Barka', 'Rustaq',
    'Seeb', 'Mutrah', 'Bahla', 'Al Buraimi', 'Khasab', 'Saham', 'Shinas',
    'Al Suwayq', 'Duqm', 'Haima', 'Adam', 'Bidbid', 'Bidiyah',
  ],
  'Kuwait': [
    'Kuwait City', 'Hawalli', 'Salmiya', 'Farwaniya', 'Jahra', 'Ahmadi',
    'Mangaf', 'Fahaheel', 'Sabah Al Salem', 'Mishref', 'Rumaithiya',
    'Fintas', 'Mahboula', 'Abu Halifa', 'Jleeb Al-Shuyoukh',
  ],
  'Bahrain': [
    'Manama', 'Riffa', 'Muharraq', 'Isa Town', 'Sitra', 'Hamad Town',
    'Budaiya', 'Jidhafs', 'Al Hidd', 'Zallaq', 'Amwaj Islands', 'Tubli',
  ],
  'Egypt': [
    'Cairo', 'Alexandria', 'Giza', 'Sharm El Sheikh', 'Hurghada', 'Luxor',
    'Aswan', 'Port Said', 'Suez', 'Mansoura', 'Tanta', 'Ismailia', 'Fayyum',
    'Zagazig', 'Damietta', 'Minya', 'Beni Suef', 'Sohag', 'Qena', 'Assiut',
    'Kafr El Sheikh', 'Marsa Alam', 'El Gouna', 'Dahab', 'Nuweiba',
    'Ras Ghareb', 'New Cairo', '6th of October City', 'Obour City', 'Shebin El Kom',
    'Damanhur', 'Banha', 'Mallawi', 'El Mahalla El Kubra',
  ],
  'Jordan': [
    'Amman', 'Aqaba', 'Irbid', 'Zarqa', 'Madaba', 'Jerash', 'Ajloun',
    'Salt', 'Karak', 'Tafilah', 'Mafraq', 'Maan', 'Russeifa', 'Sahab',
  ],
  'Lebanon': [
    'Beirut', 'Tripoli', 'Sidon', 'Jounieh', 'Byblos', 'Baalbek', 'Zahle',
    'Tyre', 'Nabatieh', 'Aley', 'Broummana', 'Batroun', 'Ehden',
  ],
  'Turkey': [
    'Istanbul', 'Ankara', 'Izmir', 'Antalya', 'Bursa', 'Adana', 'Gaziantep',
    'Konya', 'Mersin', 'Diyarbakir', 'Kayseri', 'Eskisehir', 'Trabzon',
    'Samsun', 'Denizli', 'Malatya', 'Erzurum', 'Van', 'Batman', 'Bodrum',
    'Fethiye', 'Marmaris', 'Kusadasi', 'Side', 'Alanya', 'Cappadocia',
  ],
  'Iraq': [
    'Baghdad', 'Erbil', 'Basra', 'Sulaymaniyah', 'Najaf', 'Karbala',
    'Kirkuk', 'Mosul', 'Duhok', 'Hillah', 'Nasiriyah', 'Amarah',
    'Ramadi', 'Tikrit', 'Samarra', 'Fallujah', 'Zakho',
  ],
  'Pakistan': [
    'Karachi', 'Lahore', 'Islamabad', 'Rawalpindi', 'Faisalabad', 'Peshawar',
    'Multan', 'Hyderabad', 'Quetta', 'Sialkot', 'Gujranwala', 'Bahawalpur',
    'Sargodha', 'Sukkur', 'Abbottabad', 'Mardan', 'Swat', 'Muzaffarabad',
    'Dera Ghazi Khan', 'Sahiwal', 'Larkana', 'Mirpur',
  ],
  'India': [
    'Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Chennai', 'Pune', 'Kolkata',
    'Ahmedabad', 'Surat', 'Jaipur', 'Lucknow', 'Kanpur', 'Nagpur', 'Indore',
    'Thane', 'Bhopal', 'Visakhapatnam', 'Patna', 'Vadodara', 'Ghaziabad',
    'Ludhiana', 'Agra', 'Nashik', 'Faridabad', 'Meerut', 'Rajkot', 'Varanasi',
    'Chandigarh', 'Mysore', 'Coimbatore', 'Madurai', 'Noida', 'Gurgaon',
    'Thiruvananthapuram', 'Kochi', 'Mangalore', 'Dehradun', 'Ranchi',
    'Bhubaneswar', 'Jodhpur', 'Amritsar', 'Raipur', 'Vijayawada',
    'Guwahati', 'Shimla', 'Pondicherry', 'Tiruchirappalli',
  ],
  'Philippines': [
    'Manila', 'Cebu', 'Davao', 'Quezon City', 'Makati', 'Taguig', 'Pasig',
    'Mandaluyong', 'Caloocan', 'Zamboanga', 'Antipolo', 'Pasay', 'Valenzuela',
    'Las Pinas', 'Muntinlupa', 'Parañaque', 'Baguio', 'Iloilo City',
    'Bacolod', 'Cagayan de Oro', 'General Santos', 'Tacloban',
  ],
  'Bangladesh': [
    'Dhaka', 'Chittagong', 'Sylhet', 'Khulna', 'Rajshahi', 'Rangpur',
    'Barisal', 'Comilla', 'Gazipur', 'Narayanganj', 'Mymensingh', 'Bogra',
    'Cox\'s Bazar', 'Jessore', 'Dinajpur', 'Brahmanbaria',
  ],
  'United Kingdom': [
    'London', 'Manchester', 'Birmingham', 'Edinburgh', 'Glasgow', 'Leeds',
    'Liverpool', 'Bristol', 'Sheffield', 'Newcastle', 'Nottingham', 'Southampton',
    'Leicester', 'Coventry', 'Cardiff', 'Belfast', 'Brighton', 'Oxford',
    'Cambridge', 'Aberdeen', 'Dundee', 'Reading', 'Milton Keynes', 'Plymouth',
    'Derby', 'Swansea', 'Exeter', 'York', 'Bath', 'Canterbury', 'Inverness',
  ],
  'United States': [
    'New York', 'Los Angeles', 'Chicago', 'Houston', 'San Francisco', 'Seattle',
    'Miami', 'Phoenix', 'Philadelphia', 'San Antonio', 'San Diego', 'Dallas',
    'Austin', 'Jacksonville', 'Fort Worth', 'Columbus', 'Charlotte', 'Indianapolis',
    'San Jose', 'Denver', 'Washington DC', 'Nashville', 'Boston', 'Las Vegas',
    'Portland', 'Atlanta', 'Minneapolis', 'Tampa', 'Orlando', 'St. Louis',
    'Pittsburgh', 'Cincinnati', 'Sacramento', 'Kansas City', 'Raleigh', 'Salt Lake City',
    'Detroit', 'New Orleans', 'Honolulu', 'Anchorage', 'Baltimore', 'Richmond',
    'Buffalo', 'Milwaukee', 'Tucson', 'Oklahoma City', 'Omaha', 'Boise',
  ],
  'Canada': [
    'Toronto', 'Vancouver', 'Montreal', 'Calgary', 'Ottawa', 'Edmonton',
    'Winnipeg', 'Quebec City', 'Hamilton', 'Halifax', 'Victoria', 'Saskatoon',
    'Regina', 'St. John\'s', 'Kelowna', 'Kitchener', 'London', 'Windsor',
    'Barrie', 'Oshawa', 'Sherbrooke', 'Gatineau',
  ],
  'Germany': [
    'Berlin', 'Munich', 'Frankfurt', 'Hamburg', 'Cologne', 'Stuttgart',
    'Düsseldorf', 'Dortmund', 'Essen', 'Leipzig', 'Dresden', 'Hanover',
    'Nuremberg', 'Bremen', 'Bonn', 'Mannheim', 'Karlsruhe', 'Augsburg',
    'Wiesbaden', 'Münster', 'Freiburg', 'Heidelberg', 'Aachen', 'Kiel',
  ],
  'France': [
    'Paris', 'Lyon', 'Marseille', 'Toulouse', 'Nice', 'Nantes', 'Strasbourg',
    'Montpellier', 'Bordeaux', 'Lille', 'Rennes', 'Reims', 'Le Havre',
    'Toulon', 'Grenoble', 'Dijon', 'Angers', 'Nîmes', 'Clermont-Ferrand',
    'Aix-en-Provence', 'Brest', 'Tours', 'Cannes', 'Versailles',
  ],
  'Australia': [
    'Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adelaide', 'Gold Coast',
    'Canberra', 'Hobart', 'Darwin', 'Cairns', 'Newcastle', 'Wollongong',
    'Geelong', 'Townsville', 'Sunshine Coast', 'Ballarat', 'Bendigo',
    'Toowoomba', 'Mackay', 'Launceston', 'Rockhampton',
  ],
  'Malaysia': [
    'Kuala Lumpur', 'Penang', 'Johor Bahru', 'Kota Kinabalu', 'Kuching',
    'Ipoh', 'Shah Alam', 'Petaling Jaya', 'Subang Jaya', 'Cyberjaya',
    'Putrajaya', 'Malacca', 'Seremban', 'Kuantan', 'Kota Bharu',
    'Alor Setar', 'Miri', 'Sibu', 'Sandakan', 'Tawau',
  ],
  'Singapore': ['Singapore'],
  'South Africa': [
    'Johannesburg', 'Cape Town', 'Durban', 'Pretoria', 'Port Elizabeth',
    'Bloemfontein', 'East London', 'Nelspruit', 'Polokwane', 'Kimberley',
    'Pietermaritzburg', 'Rustenburg', 'George', 'Stellenbosch', 'Sandton',
  ],
  'Nigeria': [
    'Lagos', 'Abuja', 'Port Harcourt', 'Kano', 'Ibadan', 'Kaduna', 'Enugu',
    'Benin City', 'Calabar', 'Warri', 'Uyo', 'Owerri', 'Jos', 'Ilorin',
    'Abeokuta', 'Maiduguri', 'Aba', 'Sokoto', 'Onitsha', 'Akure',
  ],
  'Morocco': [
    'Casablanca', 'Rabat', 'Marrakech', 'Tangier', 'Fes', 'Agadir',
    'Meknes', 'Oujda', 'Kenitra', 'Tetouan', 'Safi', 'Mohammedia',
    'El Jadida', 'Nador', 'Beni Mellal', 'Taza', 'Khouribga',
  ],
  'Tunisia': [
    'Tunis', 'Sfax', 'Sousse', 'Gabes', 'Kairouan', 'Bizerte', 'Ariana',
    'Monastir', 'Ben Arous', 'Nabeul', 'Hammamet', 'Mahdia', 'Tozeur',
  ],
  'Sudan': [
    'Khartoum', 'Omdurman', 'Port Sudan', 'Kassala', 'Al-Obeid', 'Wad Madani',
    'Nyala', 'El Fasher', 'Atbara', 'Gedaref', 'Dongola',
  ],
  'Yemen': [
    "Sana'a", 'Aden', 'Taiz', 'Al Hudaydah', 'Ibb', 'Mukalla', 'Dhamar',
    'Amran', 'Sayyan', 'Zinjibar', 'Seiyun', 'Marib',
  ],
  'Syria': [
    'Damascus', 'Aleppo', 'Homs', 'Latakia', 'Hama', 'Deir ez-Zor',
    'Raqqa', 'Idlib', 'Tartus', 'Daraa', 'Qamishli', 'Hasaka',
  ],
  'Libya': [
    'Tripoli', 'Benghazi', 'Misrata', 'Zawiya', 'Zliten', 'Bayda',
    'Ajdabiya', 'Sirte', 'Sebha', 'Gharyan', 'Tobruk', 'Derna',
  ],
  'Algeria': [
    'Algiers', 'Oran', 'Constantine', 'Annaba', 'Blida', 'Batna', 'Setif',
    'Djelfa', 'Biskra', 'Tlemcen', 'Bejaia', 'Sidi Bel Abbes', 'Tizi Ouzou',
    'Skikda', 'Tiaret', 'Chlef', 'El Oued', 'Ghardaia',
  ],
  'Ethiopia': [
    'Addis Ababa', 'Dire Dawa', 'Mekelle', 'Gondar', 'Bahir Dar', 'Hawassa',
    'Adama', 'Jimma', 'Harar', 'Dessie', 'Debre Markos', 'Jijiga',
  ],
  'Kenya': [
    'Nairobi', 'Mombasa', 'Kisumu', 'Nakuru', 'Eldoret', 'Thika', 'Malindi',
    'Nanyuki', 'Lamu', 'Nyeri', 'Machakos', 'Kitale', 'Garissa',
  ],
  'Japan': [
    'Tokyo', 'Osaka', 'Yokohama', 'Nagoya', 'Sapporo', 'Kobe', 'Kyoto',
    'Fukuoka', 'Kawasaki', 'Hiroshima', 'Sendai', 'Kitakyushu', 'Chiba',
    'Sakai', 'Niigata', 'Hamamatsu', 'Kumamoto', 'Sagamihara', 'Shizuoka',
    'Okayama', 'Kagoshima', 'Nara', 'Kanazawa', 'Okinawa',
  ],
  'China': [
    'Shanghai', 'Beijing', 'Shenzhen', 'Guangzhou', 'Chengdu', 'Hangzhou',
    'Wuhan', 'Nanjing', 'Chongqing', 'Tianjin', 'Suzhou', 'Xi\'an',
    'Qingdao', 'Dalian', 'Xiamen', 'Zhengzhou', 'Changsha', 'Kunming',
    'Harbin', 'Fuzhou', 'Jinan', 'Hefei', 'Ningbo', 'Dongguan', 'Foshan',
    'Shenyang', 'Guiyang', 'Nanning', 'Urumqi', 'Lanzhou',
  ],
  'South Korea': [
    'Seoul', 'Busan', 'Incheon', 'Daegu', 'Daejeon', 'Gwangju', 'Ulsan',
    'Suwon', 'Changwon', 'Seongnam', 'Goyang', 'Yongin', 'Cheongju',
    'Jeonju', 'Jeju', 'Pohang', 'Gimhae',
  ],
  'Indonesia': [
    'Jakarta', 'Surabaya', 'Bandung', 'Medan', 'Semarang', 'Makassar',
    'Palembang', 'Depok', 'Tangerang', 'Bekasi', 'Yogyakarta', 'Denpasar',
    'Balikpapan', 'Manado', 'Pontianak', 'Batam', 'Malang', 'Bogor',
    'Padang', 'Solo', 'Pekanbaru',
  ],
  'Thailand': [
    'Bangkok', 'Chiang Mai', 'Phuket', 'Pattaya', 'Nonthaburi', 'Hat Yai',
    'Nakhon Ratchasima', 'Udon Thani', 'Khon Kaen', 'Chiang Rai',
    'Krabi', 'Koh Samui', 'Hua Hin', 'Ayutthaya', 'Rayong',
  ],
  'Vietnam': [
    'Ho Chi Minh City', 'Hanoi', 'Da Nang', 'Hai Phong', 'Can Tho',
    'Bien Hoa', 'Hue', 'Nha Trang', 'Vung Tau', 'Da Lat', 'Quy Nhon',
    'Buon Ma Thuot', 'Long Xuyen', 'Ha Long',
  ],
  'Netherlands': [
    'Amsterdam', 'Rotterdam', 'The Hague', 'Utrecht', 'Eindhoven', 'Groningen',
    'Tilburg', 'Almere', 'Breda', 'Nijmegen', 'Haarlem', 'Arnhem',
    'Maastricht', 'Leiden', 'Delft',
  ],
  'Belgium': [
    'Brussels', 'Antwerp', 'Ghent', 'Bruges', 'Liège', 'Leuven', 'Namur',
    'Mechelen', 'Hasselt', 'Mons', 'Charleroi', 'Kortrijk',
  ],
  'Switzerland': [
    'Zurich', 'Geneva', 'Basel', 'Bern', 'Lausanne', 'Winterthur', 'Lucerne',
    'St. Gallen', 'Lugano', 'Biel', 'Thun', 'Fribourg', 'Zug',
  ],
  'Austria': [
    'Vienna', 'Graz', 'Linz', 'Salzburg', 'Innsbruck', 'Klagenfurt',
    'Villach', 'Wels', 'St. Pölten', 'Dornbirn',
  ],
  'Italy': [
    'Rome', 'Milan', 'Naples', 'Turin', 'Florence', 'Palermo', 'Genoa',
    'Bologna', 'Bari', 'Catania', 'Venice', 'Verona', 'Padua', 'Trieste',
    'Brescia', 'Parma', 'Modena', 'Pisa', 'Cagliari', 'Bergamo',
  ],
  'Spain': [
    'Madrid', 'Barcelona', 'Valencia', 'Seville', 'Bilbao', 'Malaga',
    'Zaragoza', 'Murcia', 'Palma de Mallorca', 'Las Palmas', 'Alicante',
    'Córdoba', 'Granada', 'Vigo', 'Valladolid', 'San Sebastián', 'Salamanca',
    'Santander', 'Marbella', 'Tenerife',
  ],
  'Portugal': [
    'Lisbon', 'Porto', 'Braga', 'Coimbra', 'Funchal', 'Faro', 'Aveiro',
    'Évora', 'Setúbal', 'Viseu', 'Leiria', 'Guimarães',
  ],
  'Sweden': [
    'Stockholm', 'Gothenburg', 'Malmö', 'Uppsala', 'Linköping', 'Västerås',
    'Örebro', 'Helsingborg', 'Norrköping', 'Jönköping', 'Umeå', 'Lund',
  ],
  'Norway': [
    'Oslo', 'Bergen', 'Trondheim', 'Stavanger', 'Drammen', 'Kristiansand',
    'Tromsø', 'Fredrikstad', 'Sandnes', 'Bodø', 'Ålesund',
  ],
  'Denmark': [
    'Copenhagen', 'Aarhus', 'Odense', 'Aalborg', 'Esbjerg', 'Randers',
    'Kolding', 'Horsens', 'Vejle', 'Roskilde', 'Herning',
  ],
  'Finland': [
    'Helsinki', 'Espoo', 'Tampere', 'Vantaa', 'Oulu', 'Turku', 'Jyväskylä',
    'Lahti', 'Kuopio', 'Pori', 'Rovaniemi',
  ],
  'Ireland': [
    'Dublin', 'Cork', 'Galway', 'Limerick', 'Waterford', 'Kilkenny',
    'Drogheda', 'Dundalk', 'Athlone', 'Sligo',
  ],
  'Poland': [
    'Warsaw', 'Krakow', 'Wroclaw', 'Poznan', 'Gdansk', 'Lodz', 'Katowice',
    'Lublin', 'Szczecin', 'Bydgoszcz', 'Bialystok', 'Torun', 'Rzeszow',
  ],
  'Czech Republic': [
    'Prague', 'Brno', 'Ostrava', 'Plzen', 'Liberec', 'Olomouc', 'Hradec Kralove',
    'Ceske Budejovice', 'Pardubice', 'Usti nad Labem',
  ],
  'Romania': [
    'Bucharest', 'Cluj-Napoca', 'Timisoara', 'Iasi', 'Constanta', 'Brasov',
    'Sibiu', 'Craiova', 'Galati', 'Oradea', 'Arad',
  ],
  'Hungary': [
    'Budapest', 'Debrecen', 'Szeged', 'Miskolc', 'Pécs', 'Győr',
    'Nyíregyháza', 'Kecskemét', 'Székesfehérvár',
  ],
  'Greece': [
    'Athens', 'Thessaloniki', 'Patras', 'Heraklion', 'Larissa', 'Volos',
    'Rhodes', 'Ioannina', 'Chania', 'Kavala', 'Corfu', 'Mykonos', 'Santorini',
  ],
  'Russia': [
    'Moscow', 'Saint Petersburg', 'Novosibirsk', 'Yekaterinburg', 'Kazan',
    'Nizhny Novgorod', 'Chelyabinsk', 'Samara', 'Rostov-on-Don', 'Ufa',
    'Krasnoyarsk', 'Voronezh', 'Perm', 'Volgograd', 'Krasnodar', 'Sochi',
  ],
  'Ukraine': [
    'Kyiv', 'Kharkiv', 'Odessa', 'Dnipro', 'Lviv', 'Zaporizhzhia', 'Vinnytsia',
    'Mykolaiv', 'Poltava', 'Chernihiv', 'Ivano-Frankivsk', 'Ternopil',
  ],
  'Brazil': [
    'São Paulo', 'Rio de Janeiro', 'Brasília', 'Salvador', 'Fortaleza',
    'Belo Horizonte', 'Curitiba', 'Recife', 'Manaus', 'Porto Alegre',
    'Belém', 'Goiânia', 'Campinas', 'Florianópolis', 'Natal', 'Vitória',
  ],
  'Mexico': [
    'Mexico City', 'Guadalajara', 'Monterrey', 'Puebla', 'Cancún', 'Tijuana',
    'León', 'Mérida', 'Querétaro', 'San Luis Potosí', 'Aguascalientes',
    'Chihuahua', 'Morelia', 'Veracruz', 'Oaxaca', 'Playa del Carmen',
  ],
  'Argentina': [
    'Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'San Miguel de Tucumán',
    'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'Bariloche',
  ],
  'Colombia': [
    'Bogotá', 'Medellín', 'Cali', 'Barranquilla', 'Cartagena', 'Bucaramanga',
    'Pereira', 'Santa Marta', 'Manizales', 'Ibagué', 'Cúcuta',
  ],
  'Chile': [
    'Santiago', 'Valparaíso', 'Concepción', 'Antofagasta', 'Viña del Mar',
    'Temuco', 'La Serena', 'Iquique', 'Rancagua', 'Puerto Montt', 'Punta Arenas',
  ],
  'Peru': [
    'Lima', 'Arequipa', 'Cusco', 'Trujillo', 'Chiclayo', 'Piura', 'Iquitos',
    'Huancayo', 'Tacna', 'Pucallpa', 'Ayacucho',
  ],
  'Ghana': [
    'Accra', 'Kumasi', 'Tamale', 'Takoradi', 'Tema', 'Cape Coast',
    'Ho', 'Sunyani', 'Koforidua', 'Bolgatanga',
  ],
  'Tanzania': [
    'Dar es Salaam', 'Dodoma', 'Mwanza', 'Arusha', 'Zanzibar', 'Mbeya',
    'Morogoro', 'Tanga', 'Iringa',
  ],
  'Uganda': [
    'Kampala', 'Entebbe', 'Jinja', 'Gulu', 'Mbarara', 'Mbale', 'Lira',
    'Fort Portal', 'Masaka',
  ],
  'Rwanda': ['Kigali', 'Butare', 'Gisenyi', 'Ruhengeri', 'Gitarama'],
  'Sri Lanka': [
    'Colombo', 'Kandy', 'Galle', 'Jaffna', 'Negombo', 'Anuradhapura',
    'Trincomalee', 'Batticaloa', 'Matara', 'Ratnapura',
  ],
  'Nepal': [
    'Kathmandu', 'Pokhara', 'Lalitpur', 'Biratnagar', 'Bharatpur',
    'Birgunj', 'Dharan', 'Janakpur', 'Butwal', 'Hetauda',
  ],
  'Myanmar': [
    'Yangon', 'Mandalay', 'Naypyidaw', 'Bagan', 'Mawlamyine', 'Taunggyi',
    'Pathein', 'Monywa',
  ],
  'Cambodia': [
    'Phnom Penh', 'Siem Reap', 'Battambang', 'Sihanoukville', 'Kampong Cham',
    'Kampot', 'Poipet',
  ],
  'New Zealand': [
    'Auckland', 'Wellington', 'Christchurch', 'Hamilton', 'Tauranga', 'Dunedin',
    'Palmerston North', 'Napier', 'Nelson', 'Rotorua', 'Queenstown',
  ],
  'Israel': [
    'Tel Aviv', 'Jerusalem', 'Haifa', 'Beersheba', 'Netanya', 'Rishon LeZion',
    'Ashdod', 'Petah Tikva', 'Holon', 'Herzliya', 'Ra\'anana', 'Eilat',
  ],
  'Palestine': [
    'Ramallah', 'Gaza', 'Nablus', 'Hebron', 'Bethlehem', 'Jenin', 'Tulkarm',
    'Jericho', 'Khan Yunis', 'Rafah',
  ],
};

export const COUNTRIES = Object.keys(COUNTRY_CITIES).sort();

/** Returns all "City, Country" options sorted alphabetically */
export function getAllCityCountryOptions(): { label: string; value: string }[] {
  const options: { label: string; value: string }[] = [];
  for (const [country, cities] of Object.entries(COUNTRY_CITIES)) {
    for (const city of cities) {
      const val = `${city}, ${country}`;
      options.push({ label: val, value: val });
    }
  }
  return options.sort((a, b) => a.label.localeCompare(b.label));
}

/** Comprehensive list of industries */
export const INDUSTRIES: string[] = [
  'Accounting & Auditing',
  'Advertising & Marketing',
  'Aerospace & Defense',
  'Agriculture & Farming',
  'Architecture & Planning',
  'Automotive',
  'Aviation & Airlines',
  'Banking & Financial Services',
  'Biotechnology',
  'Broadcasting & Media',
  'Business Consulting',
  'Chemicals',
  'Civil Engineering',
  'Cloud Computing',
  'Construction',
  'Consumer Electronics',
  'Consumer Goods & FMCG',
  'Cybersecurity',
  'Data Analytics & AI',
  'Design & Creative Services',
  'E-Commerce',
  'Education & Training',
  'Electrical & Electronics',
  'Energy & Utilities',
  'Entertainment & Gaming',
  'Environmental Services',
  'Events & Conferences',
  'Fashion & Apparel',
  'Film & Animation',
  'Financial Technology (FinTech)',
  'Food & Beverage',
  'Furniture & Interiors',
  'Government & Public Sector',
  'Healthcare & Medical',
  'Hospitality & Hotels',
  'Human Resources & Recruitment',
  'Import & Export',
  'Industrial Manufacturing',
  'Information Technology (IT)',
  'Insurance',
  'Interior Design',
  'International Development',
  'Investment & Private Equity',
  'Islamic Finance',
  'Jewelry & Luxury Goods',
  'Legal Services',
  'Logistics & Supply Chain',
  'Management Consulting',
  'Maritime & Shipping',
  'Mechanical Engineering',
  'Medical Devices',
  'Mining & Metals',
  'Music & Audio',
  'NGO & Nonprofit',
  'Oil & Gas',
  'Petrochemicals',
  'Pharmaceuticals',
  'Photography',
  'Printing & Publishing',
  'Professional Services',
  'Property Management',
  'Public Relations',
  'Quality Assurance & Testing',
  'Real Estate & Development',
  'Renewable Energy',
  'Research & Development',
  'Restaurants & Catering',
  'Retail',
  'Robotics & Automation',
  'SaaS & Software',
  'Safety & Security Services',
  'Semiconductors',
  'Social Media',
  'Sports & Fitness',
  'Staffing & Outsourcing',
  'Telecommunications',
  'Textiles & Garments',
  'Tourism & Travel',
  'Trading & Distribution',
  'Transportation',
  'Urban Planning',
  'Venture Capital',
  'Veterinary Services',
  'Warehousing & Storage',
  'Water & Waste Management',
  'Wholesale',
].sort();

export function getIndustryOptions(): { label: string; value: string }[] {
  return INDUSTRIES.map(i => ({ label: i, value: i }));
}
